import { Length, ModelBase, Property, Range, Required, ShortString } from '@skylab-shared/core';

export class CurrencyModel extends ModelBase {
    @Property({ identifiable: true })
    public id: number;

    @Property(String)
    public externalId: string | null;

    @Property()
    public default: boolean;

    @Property()
    @ShortString('data-model.currency.validation.name.length')
    @Required('data-model.currency.validation.name.non-empty')
    public name: string;

    @Property()
    @Range({ min: 0, max: 6 }, 'data-model.currency.validation.precision.range')
    public precision: number;

    @Property()
    @Required('data-model.currency.validation.symbol.non-empty')
    @Length({ max: 3 }, 'data-model.currency.validation.symbol.length')
    public symbol: string;
}
